/**
 * Form Detection Script
 *
 * This script detects browser, device type, and ad blocker status and fills
 * existing hidden fields in the contact form.
 */

(function($) {
  'use strict';

  /**
   * Detect browser information
   * @returns {string} Browser name
   */
  function detectBrowser() {
    const userAgent = navigator.userAgent;

    if (userAgent.match(/opr\//i)) {
      return 'Opera';
    } else if (userAgent.match(/edg/i)) {
      return 'Edge';
    } else if (userAgent.match(/chrome|chromium|crios/i)) {
      return 'Chrome';
    } else if (userAgent.match(/firefox|fxios/i)) {
      return 'Firefox';
    } else if (userAgent.match(/safari/i)) {
      return 'Safari';
    } else {
      return 'Unknown';
    }
  }

  /**
   * Detect device type
   * @returns {string} Device type: mobile, tablet, or desktop
   */
  function detectDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();

    // Check if mobile
    if (/mobile|android|iphone|ipod|blackberry|opera mini|iemobile|wpdesktop/i.test(userAgent)) {
      return 'mobile';
    }

    // Check if tablet (using modern approach)
    if (/ipad|tablet|playbook|silk/i.test(userAgent) ||
      (/macintosh/i.test(userAgent) && 'ontouchend' in document)) {
      return 'tablet';
    }

    // Default to desktop
    return 'desktop';
  }

  /**
   * Store data in a cookie
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   * @param {number} days - Number of days until expiration
   */
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  /**
   * Fill the hidden form fields with detected values
   * @param {Object} data - The data to fill in the form
   */
  function fillHiddenFields(data) {
    // Fill navigator field
    if ($('input[name="navigator"]').length > 0) {
      $('input[name="navigator"]').val(data.browser);
    }

    // Fill device type field
    if ($('input[name="deviceType"]').length > 0) {
      $('input[name="deviceType"]').val(data.deviceType);
    }

    // Fill ad blocker field
    if ($('input[name="isAb"]').length > 0) {
      $('input[name="isAb"]').val(data.isAb);
    }

    // Store in cookie for API usage
    setCookie('form_auto_data', JSON.stringify(data), 30);
  }

  /**
   * Main initialization function
   */
  function init() {
    // Get browser info
    const browser = detectBrowser();

    // Get device type
    const deviceType = detectDeviceType();

    // Get adBlocker status from dataLayer if available
    let isAb = false;

    if (typeof window.dataLayer !== 'undefined') {
      for (let i = 0; i < window.dataLayer.length; i++) {
        if (typeof window.dataLayer[i].adBlockerDetected !== 'undefined') {
          isAb = window.dataLayer[i].adBlockerDetected;
          break;
        }
      }
    }

    // Create data object
    const data = {
      browser: browser,
      deviceType: deviceType,
      isAb: isAb
    };

    // Fill hidden fields with detected values
    fillHiddenFields(data);
  }

  // Initialize on document ready
  $(document).ready(function() {
    // Check if we're on a contact form page
    if ($('.wrapper-step').length > 0) {
      // Wait a bit for ab-detection.js to complete if dataLayer isn't ready
      if (typeof window.dataLayer !== 'undefined') {
        let hasAdBlockerData = false;

        for (let i = 0; i < window.dataLayer.length; i++) {
          if (typeof window.dataLayer[i].adBlockerDetected !== 'undefined') {
            hasAdBlockerData = true;
            break;
          }
        }

        if (hasAdBlockerData) {
          init();
        } else {
          setTimeout(init, 1000);
        }
      } else {
        setTimeout(init, 1000);
      }
    }
  });

})(jQuery);
